import ATooltip, { TooltipProps } from 'antd/lib/tooltip';
import { FC } from 'react';
import './Tooltip.scss';

export const Tooltip: FC<TooltipProps> = (props) => {
  return <ATooltip {...props} />;
};
